import { Pipe, PipeTransform } from '@angular/core';
import { PerareFeature } from '../../../../shared/services/api/listing-api.types';
import { polygon } from '@turf/helpers';
import { distance, Feature, FeatureCollection, featureCollection, Geometry, LineString } from '@turf/turf';

export interface LineSizeProps {
  distance: string;
  showSizes: boolean;
  showDegrees: boolean;
}

@Pipe({
  name: 'polygonToLines',
  standalone: true,
})
export class PolygonToLinesPipe implements PipeTransform {
  transform(features: PerareFeature[]): FeatureCollection<LineString, LineSizeProps> {
    const lineFeatures = features.reduce(
      (acc, feature) => {
        const geometry = feature.geometry as any;
        if (geometry.type !== 'Polygon') {
          return acc;
        }
        const lines = this.getSizeLinesDataFromPolygon(
          polygon(geometry.coordinates),
          feature.properties?.showSizes !== false,
          feature.properties?.showDegrees !== false,
        );
        return [...acc, ...lines];
      },
      [] as Feature<LineString, LineSizeProps>[],
    );

    return featureCollection(lineFeatures);
  }

  private getSizeLinesDataFromPolygon(
    polygon: Feature<Geometry, any>,
    showSizes: boolean,
    showDegrees: boolean,
  ): Feature<LineString, LineSizeProps>[] {
    const points: [number, number][] = polygon.geometry.coordinates[0] as [number, number][];
    const lineStrings: Feature<LineString, LineSizeProps>[] = [];

    for (let i = 0; i < points.length; i++) {
      const start = points[i];
      let end = points[i + 1];
      if (!end) {
        end = points[0];
      }

      lineStrings.push({
        type: 'Feature',
        properties: {
          distance: distance(start, end, { units: 'meters' }).toFixed(0).toString() + 'm',
          showSizes,
          showDegrees,
        },
        geometry: {
          type: 'LineString',
          coordinates: [start, end],
        },
      });
    }

    return lineStrings;
  }
}
